import React from 'react';

const EmergencyToolbox: React.FC = () => {
  return (
    <div>
      <div className="flex justify-center p-10">
        <iframe
          src="https://padlet.com/eufmdFAST/emergency-toolbox-for-fast-diseases-lrhxjry947a6fki2"
          width="1860"
          height="898"
          frameBorder="0"
          title="Emergency Toolbox"
        ></iframe>
      </div>
    </div>
  );
};

export default EmergencyToolbox;
